<template>
	<section class="marketing-section" :style="`background-color: ${backgroundColor}`">
		<div class="container">
			<h2 v-if="relatedArticlesSection.sectionHeading" class="heading-2">{{
				relatedArticlesSection.sectionHeading
			}}</h2>
			<div class="grid-md gutters-300-md pt-200-lg pt-100">
				<ArticleCard
					v-for="(article, id) in relatedArticlesSection.relatedArticles"
					:key="id"
					:article="article"
					:show-cover-image="true"
					class="col-3-md"
				/>
			</div>
		</div>
	</section>
</template>
<script setup lang="ts">
import ArticleCard from '@components/blog/article-card.vue';
import { computed } from 'vue';
import { mapInvestorUpdateArticleTeasers } from '@utils/blog';
import { SanityRelatedArticlesSection } from 'types/sanity/blog-education-center';

interface Props {
	relatedArticlesSection: SanityRelatedArticlesSection;
}
const props = defineProps<Props>();

const relatedArticlesSection: SanityRelatedArticlesSection = {
	...props.relatedArticlesSection,
	relatedArticles: mapInvestorUpdateArticleTeasers(props.relatedArticlesSection.relatedArticles ?? [])
};

const backgroundColor = computed((): string => {
	return relatedArticlesSection.backgroundColor?.hex ?? '#ffffff';
});
</script>
